import { Injectable } from '@angular/core';
import { LgvModel } from '../../data-models/longevity.model';

@Injectable({
    providedIn: 'root'
})

export class LgvDataHelper {

    public LoanTypeFromLgvOpp(lgvOpp: LgvModel.Opportunity): string {
        if (!lgvOpp) {
            return '';
        }
        return lgvOpp.opportunityType.name;
    }

    public LoanTypeFromDCCOpp(dccOpp: any): string {
        //console.log('LoanTypeFromDCCOpp()');
        //console.log(dccOpp);

        if (!dccOpp) {
            return '';
        }

        if (dccOpp.Product.amortizationType === 'ARM') {
            const armFixedYears = this.ArmFixedTermNumericYears(dccOpp.QuoteResult.armFixedTerm);
            const armSubsequentChangePeriod = this.ArmFixedTermNumericMonths(dccOpp.QuoteResult.armSubsequentChangePeriod);
            return `${armFixedYears}/${armSubsequentChangePeriod} ARM`;
        }
        else {
            return `${dccOpp.Product.amortizationTerm} Yr Fixed`;
        }
    }

    public ArmFixedTermNumericMonths(armFixedTermStr: string): number {

        switch (armFixedTermStr) {
            case 'OneMonth': return 1;
            case 'ThreeMonth': return 3;
            case 'SixMonth': return 6;
            case 'OneYear': return 12;
            case 'TwoYear': return 2 * 12;
            case 'ThreeYear': return 3 * 12;
            case 'FiveYear': return 5 * 12;
            case 'SixYear': return 6 * 12;
            case 'SevenYear': return 7 * 12;
            case 'TenYear': return 10 * 12;
            case 'FifteenYear': return 15 * 12;

            // support OB armSubsequentChangePeriod
            case '6 Mo': return 6;

            default: return null;
        }

    }
    public ArmFixedTermNumericYears(armFixedTermStr: string): number {
        const result = this.ArmFixedTermNumericMonths(armFixedTermStr);
        return result == null ? null : result / 12;
    }


    public loanTermYears(loanTerm): number {
        try { return +loanTerm / 12; }
        catch (ex) { return 0; }
    }
}
